import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import styles from './../style/ProfileSelectorModal.module.scss';

const ProfileSelectorModal = ({ show, onClose, onShow, user_profile_type }) => {
  return (
    <>
      <Modal show={show} onHide={onClose} centered aria-label="Выберите ваш профиль">
        <Modal.Header closeButton>
          <div></div>
        </Modal.Header>
        <Modal.Body className="text-center">
          <Modal.Title className="mb-2">Выберите ваш профиль</Modal.Title>
          <p className={styles.modalText}>Для совершения покупок, выберите один из вариантов</p>

          <div className={styles.buttonsContainer}>
            <Button 
              variant={user_profile_type != `legal` ? `primary` : `light`}
              href={`https://stomahelp.ru/`}
              className={`${styles.profileButton} ${user_profile_type != `legal` ? styles.legalButton : styles.simleButton}`}
            >
              Физическое лицо
            </Button>
            <Button 
              variant={user_profile_type == `legal` ? `primary` : `light` }
              href={`https://ur.stomahelp.ru/`}
              className={`${styles.profileButton} ${user_profile_type == `legal` ? styles.legalButton : styles.simleButton}`}
            >
              Юридическое лицо
            </Button>
          </div>
          
          <p className={styles.authText}>
            Есть учетная запись? <a className={styles.authLink} href="/lichnyij-kabinet/">Авторизируйтесь</a>
          </p>
        </Modal.Body>
      </Modal>

      {user_profile_type && (
        <div className={user_profile_type === 'legal' ? styles.profileBadge : styles.profileBadgeR}>
          <a href={`https://ur.stomahelp.ru/`}>
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11.5" cy="11.5" r="11" stroke="white"/>
              <path d="M7.39746 12.7216H4.39462V11.9773H7.38609C7.64367 11.9773 7.85674 11.9347 8.0253 11.8494C8.19386 11.7623 8.31886 11.643 8.4003 11.4915C8.48174 11.3381 8.52246 11.1619 8.52246 10.9631C8.52246 10.7661 8.48174 10.59 8.4003 10.4347C8.31886 10.2794 8.19481 10.1572 8.02814 10.0682C7.86147 9.97727 7.65125 9.93182 7.39746 9.93182H6.15882V15H5.28382V9.18182H7.39746C7.83875 9.18182 8.20712 9.26136 8.50257 9.42045C8.79992 9.57955 9.02246 9.79356 9.17018 10.0625C9.31981 10.3314 9.39462 10.6307 9.39462 10.9602C9.39462 11.2936 9.31886 11.5937 9.16734 11.8608C9.01772 12.1259 8.79424 12.3362 8.49689 12.4915C8.20143 12.6449 7.83496 12.7216 7.39746 12.7216ZM7.44007 13.2102V13.9574H4.39462V13.2102H7.44007ZM12.4684 12.7216H9.46555V11.9773H12.457C12.7146 11.9773 12.9277 11.9347 13.0962 11.8494C13.2648 11.7623 13.3898 11.643 13.4712 11.4915C13.5527 11.3381 13.5934 11.1619 13.5934 10.9631C13.5934 10.7661 13.5527 10.59 13.4712 10.4347C13.3898 10.2794 13.2657 10.1572 13.0991 10.0682C12.9324 9.97727 12.7222 9.93182 12.4684 9.93182H11.2298V15H10.3548V9.18182H12.4684C12.9097 9.18182 13.2781 9.26136 13.5735 9.42045C13.8709 9.57955 14.0934 9.79356 14.2411 10.0625C14.3907 10.3314 14.4656 10.6307 14.4656 10.9602C14.4656 11.2936 14.3898 11.5937 14.2383 11.8608C14.0887 12.1259 13.8652 12.3362 13.5678 12.4915C13.2724 12.6449 12.9059 12.7216 12.4684 12.7216ZM12.511 13.2102V13.9574H9.46555V13.2102H12.511ZM17.5393 12.7216H14.5365V11.9773H17.528C17.7855 11.9773 17.9986 11.9347 18.1672 11.8494C18.3357 11.7623 18.4607 11.643 18.5422 11.4915C18.6236 11.3381 18.6643 11.1619 18.6643 10.9631C18.6643 10.7661 18.6236 10.59 18.5422 10.4347C18.4607 10.2794 18.3367 10.1572 18.17 10.0682C18.0033 9.97727 17.7931 9.93182 17.5393 9.93182H16.3007V15H15.4257V9.18182H17.5393C17.9806 9.18182 18.349 9.26136 18.6444 9.42045C18.9418 9.57955 19.1643 9.79356 19.3121 10.0625C19.4617 10.3314 19.5365 10.6307 19.5365 10.9602C19.5365 11.2936 19.4607 11.5937 19.3092 11.8608C19.1596 12.1259 18.9361 12.3362 18.6388 12.4915C18.3433 12.6449 17.9768 12.7216 17.5393 12.7216ZM17.5819 13.2102V13.9574H14.5365V13.2102H17.5819Z" fill="white"/>
            </svg>
            <div>Оптовый клиент</div>
          </a>
          <a href={`https://stomahelp.ru/`}>
            <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="11.5" cy="11.5" r="11" stroke="white"/>
              <path d="M12.4684 12.7216H9.46555V11.9773H12.457C12.7146 11.9773 12.9277 11.9347 13.0962 11.8494C13.2648 11.7623 13.3898 11.643 13.4712 11.4915C13.5527 11.3381 13.5934 11.1619 13.5934 10.9631C13.5934 10.7661 13.5527 10.59 13.4712 10.4347C13.3898 10.2794 13.2657 10.1572 13.0991 10.0682C12.9324 9.97727 12.7222 9.93182 12.4684 9.93182H11.2298V15H10.3548V9.18182H12.4684C12.9097 9.18182 13.2781 9.26136 13.5735 9.42045C13.8709 9.57955 14.0934 9.79356 14.2411 10.0625C14.3907 10.3314 14.4656 10.6307 14.4656 10.9602C14.4656 11.2936 14.3898 11.5937 14.2383 11.8608C14.0887 12.1259 13.8652 12.3362 13.5678 12.4915C13.2724 12.6449 12.9059 12.7216 12.4684 12.7216ZM12.511 13.2102V13.9574H9.46555V13.2102H12.511Z" fill="white"/>
            </svg>
            <div>Розничный клиент</div>
          </a>
        </div>
      )}
    </>
  );
};

ProfileSelectorModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onShow: PropTypes.func.isRequired,
  user_profile_type: PropTypes.string
};

export default ProfileSelectorModal;